import React from "react";
// import { Link } from "react-router-dom";
import { Box } from "@mui/material";

const Logo = () => {
  return (
    <Box sx={{ marginTop: 4, marginBottom: 2, display: 'flex', justifyContent: 'center' }}>
        <img width="300" height="93" src="/logo-text-black.png" alt="logo"></img>
      {/* <Link to="/"> */}
        {/* <Box component="img" src="./../../../assets/beer.png" alt="logo"/> */}
      {/* </Link> */}
    </Box>
  );
};

export default Logo;
